import moment from 'moment';
import PropTypes from 'prop-types';
import ReactTable from 'react-table-6';
import { toast } from 'react-toastify';
import Box from '@material-ui/core/Box';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Autocomplete from '@mui/material/Autocomplete';
import Typography from '@material-ui/core/Typography';
import { useDispatch, useSelector } from 'react-redux';
import { Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import { Modal, ModalBody, ModalHeader, Card, CardHeader, CardBody, CardTitle, Button } from 'reactstrap';
import { createTask, getAllCampaign, updateTask, updateStatus, getCampaignLogs, getSingleTask, createScheduleEmail } from '../../store/Campaign';
import "react-datepicker/dist/react-datepicker.css";
import './index.css';
import { getWorkspacePath } from '../../utils/workspaceUtils';

import CampaignDetails from './campaign';
import CampaignModal from './modals';
import CreateCampaignModal from './modals';
import WorkspaceHeader from '../../components/workspaceHeader';
import filterCaseInsensitive from '../../static/filter-insensitive'

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};

const initialCreate = {
  name: '',
  assistantId: '',
  createdBy: localStorage.getItem('userId') || '',
  phoneNumber: [],
  callsInterval: '',
  intervalTime: '',

};

// Dropdown options
const optionsData = [
  { value: "RemoteJobLab", label: "Remote Job Lab" },
  { value: "CreateWorkspace", label: "Create Workspace", icon: <><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" /><path d="M5 12H19" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
];

// Dropdown options
const optionsStatus = [
  { value: "allStatus", label: "All statues", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" stroke="#242424" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
  { value: "active", label: "Active", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.75 4.08167C3.75 3.2905 4.62525 2.81266 5.29076 3.24049L12.9415 8.15882C13.5538 8.55246 13.5538 9.44754 12.9415 9.84118L5.29076 14.7595C4.62525 15.1873 3.75 14.7095 3.75 13.9183V4.08167Z" fill="var(--sa-dark-accent-light)" /></svg></> },
  { value: "draft", label: "Draft", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 2.25H3.75C3.35218 2.25 2.97064 2.40804 2.68934 2.68934C2.40804 2.97064 2.25 3.35218 2.25 3.75V14.25C2.25 14.6478 2.40804 15.0294 2.68934 15.3107C2.97064 15.592 3.35218 15.75 3.75 15.75H14.25C14.6478 15.75 15.0294 15.592 15.3107 15.3107C15.592 15.0294 15.75 14.6478 15.75 14.25V9" stroke="#242424" stroke-linecap="round" stroke-linejoin="round" /><path d="M13.7812 1.96892C14.0796 1.67055 14.4842 1.50293 14.9062 1.50293C15.3282 1.50293 15.7328 1.67055 16.0312 1.96892C16.3296 2.26729 16.4972 2.67196 16.4972 3.09392C16.4972 3.51588 16.3296 3.92055 16.0312 4.21892L9.27145 10.9794C9.09336 11.1574 8.87335 11.2876 8.6317 11.3582L6.47695 11.9882C6.41241 12.007 6.344 12.0081 6.27888 11.9914C6.21376 11.9748 6.15432 11.9409 6.10678 11.8933C6.05925 11.8458 6.02536 11.7864 6.00868 11.7212C5.992 11.6561 5.99312 11.5877 6.01195 11.5232L6.64195 9.36842C6.71284 9.12696 6.84335 8.90721 7.02145 8.72942L13.7812 1.96892Z" stroke="#242424" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
  { value: "paused", label: "Paused", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 3H4.5V15H7.5V3Z" fill="#FFB100" /><path d="M13.5 3H10.5V15H13.5V3Z" fill="#FFB100" /></svg></> },
  { value: "rrors", label: "Errors", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.96568 3.88897C7.18535 3.13969 6.13933 2.73108 5.05774 2.75304C3.97614 2.77499 2.94757 3.22571 2.19829 4.00604C1.44902 4.78636 1.04041 5.83238 1.06236 6.91398C1.08432 7.99557 1.53504 9.02414 2.31536 9.77342L8.59919 16.148C8.65153 16.2011 8.71392 16.2433 8.78273 16.2721C8.85153 16.3009 8.92538 16.3158 8.99997 16.3158C9.07457 16.3158 9.14841 16.3009 9.21722 16.2721C9.28603 16.2433 9.34841 16.2011 9.40075 16.148L15.6797 9.77342C16.4452 9.00885 16.8756 7.9715 16.8762 6.88958C16.8769 5.80765 16.4477 4.76978 15.6832 4.00428C14.9186 3.23878 13.8813 2.80835 12.7993 2.80769C11.7174 2.80703 10.6795 3.23619 9.91404 4.00076L8.19841 5.61795L10.0547 7.47561C10.107 7.52785 10.1484 7.58989 10.1768 7.65817C10.2051 7.72646 10.2196 7.79966 10.2196 7.87358C10.2196 7.9475 10.2051 8.02069 10.1768 8.08898C10.1484 8.15727 10.107 8.2193 10.0547 8.27154L8.5999 9.72631C8.54759 9.77853 8.48551 9.81993 8.4172 9.84815C8.34889 9.87638 8.27569 9.89087 8.20178 9.8908C8.12787 9.89074 8.0547 9.87612 7.98644 9.84777C7.91818 9.81943 7.85617 9.77792 7.80396 9.72561C7.75174 9.6733 7.71034 9.61122 7.68212 9.54291C7.65389 9.4746 7.6394 9.4014 7.63947 9.32749C7.63953 9.25358 7.65415 9.18041 7.6825 9.11215C7.71084 9.04389 7.75235 8.98189 7.80466 8.92967L8.85935 7.87498L6.99607 6.00608C6.94251 5.95256 6.9003 5.88878 6.87198 5.81856C6.84366 5.74835 6.82981 5.67313 6.83125 5.59743C6.8327 5.52173 6.84941 5.4471 6.88039 5.37802C6.91137 5.30893 6.95597 5.24681 7.01154 5.19537L7.96427 4.29678C7.99193 4.27051 8.01395 4.23888 8.029 4.20382C8.04405 4.16877 8.05181 4.13102 8.05181 4.09287C8.05181 4.05473 8.04405 4.01698 8.029 3.98192C8.01395 3.94687 7.99193 3.91524 7.96427 3.88897H7.96568Z" fill="#FF0000" /></svg></> },
  { value: "completed", label: "Completed", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.875 12.0454L5.0625 9.23231L5.85731 8.4375L7.875 10.4546L12.1416 6.1875L12.9375 6.98344L7.875 12.0454Z" fill="#2ECA8B" /><path d="M9 1.125C7.44248 1.125 5.91992 1.58686 4.62489 2.45218C3.32985 3.31749 2.32049 4.5474 1.72445 5.98637C1.12841 7.42534 0.972461 9.00874 1.27632 10.5363C1.58018 12.0639 2.3302 13.4671 3.43154 14.5685C4.53288 15.6698 5.93607 16.4198 7.46367 16.7237C8.99127 17.0275 10.5747 16.8716 12.0136 16.2756C13.4526 15.6795 14.6825 14.6702 15.5478 13.3751C16.4131 12.0801 16.875 10.5575 16.875 9C16.875 6.91142 16.0453 4.90838 14.5685 3.43153C13.0916 1.95469 11.0886 1.125 9 1.125ZM9 15.75C7.66498 15.75 6.35994 15.3541 5.2499 14.6124C4.13987 13.8707 3.27471 12.8165 2.76382 11.5831C2.25293 10.3497 2.11925 8.99251 2.3797 7.68314C2.64015 6.37377 3.28303 5.17103 4.22703 4.22703C5.17104 3.28302 6.37377 2.64015 7.68314 2.3797C8.99252 2.11925 10.3497 2.25292 11.5831 2.76381C12.8165 3.2747 13.8707 4.13987 14.6124 5.2499C15.3541 6.35993 15.75 7.66498 15.75 9C15.75 10.7902 15.0388 12.5071 13.773 13.773C12.5071 15.0388 10.7902 15.75 9 15.75Z" fill="#2ECA8B" /></svg></> },
  { value: "Evergreen", label: "Evergreen", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 9.5C7.69231 7.75726 6.38462 6.01452 4.69231 6.01452C3.94349 5.94691 3.19214 6.1167 2.55694 6.49709C1.92173 6.87749 1.43887 7.44679 1.18462 8.1151C1.01477 8.55892 1 9.5 1 9.5C1 9.5 1.01354 10.4422 1.18462 10.8849C1.43887 11.5532 1.92173 12.1225 2.55694 12.5029C3.19214 12.8833 3.94349 13.0531 4.69231 12.9855C5.37054 12.9741 6.02337 12.7399 6.53846 12.3232C6.74359 12.1566 7.52308 11.3587 9 9.5ZM9 9.5C10.3077 11.2427 11.6154 12.9855 13.3077 12.9855C14.0565 13.0531 14.8079 12.8833 15.4431 12.5029C16.0783 12.1225 16.5611 11.5532 16.8154 10.8849C16.9865 10.4422 17 9.5 17 9.5C17 9.5 16.9852 8.55892 16.8154 8.1151C16.5611 7.44679 16.0783 6.87749 15.4431 6.49709C14.8079 6.1167 14.0565 5.94691 13.3077 6.01452C12.2821 6.01452 9.98462 6.71162 9 9.5Z" stroke="var(--sa-dark-accent-light)" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
  { value: "salesaicamp", label: "Sales AI Camp...", icon: <><svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.875 5.375C14.1734 5.375 14.4595 5.25647 14.6705 5.0455C14.8815 4.83452 15 4.54837 15 4.25C15 3.95163 14.8815 3.66548 14.6705 3.4545C14.4595 3.24353 14.1734 3.125 13.875 3.125C13.5766 3.125 13.2905 3.24353 13.0795 3.4545C12.8685 3.66548 12.75 3.95163 12.75 4.25C12.75 4.54837 12.8685 4.83452 13.0795 5.0455C13.2905 5.25647 13.5766 5.375 13.875 5.375ZM1.9425 8.81L8.6925 2.06C8.9625 1.79 9.3375 1.625 9.75 1.625H15C15.8325 1.625 16.5 2.2925 16.5 3.125V8.375C16.5 8.7875 16.335 9.1625 16.0575 9.4325L9.315 16.1825C9.0375 16.4525 8.6625 16.625 8.25 16.625C7.8375 16.625 7.4625 16.4525 7.1925 16.1825L1.9425 10.9325C1.665 10.6625 1.5 10.2875 1.5 9.875C1.5 9.455 1.6725 9.08 1.9425 8.81Z" fill="var(--sa-dark-accent-light)" /></svg></> },
];

// Dropdown options
const optionsNewestfirst = [
  { value: "Newestfirst", label: "Newest first" },
  { value: "Oldestfirst", label: "Oldest first" },
  { value: "NameA-Z", label: "Name A-Z" },
  { value: "NameZ-A", label: "Name Z-A" },
];



const Campaign = (props) => {
  const history = useHistory();

  const dispatch = useDispatch();
  const { currentWorkspace } = useSelector(state => state['Settings']);
  const [value, setValue] = useState(0);
  const [logs, setLogs] = useState(null);
  const [progress, setProgress] = useState(10);
  const [isEditing, setIsEditing] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [scheduledTime, setScheduledTime] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [logsCampaignId, setLogsCampaignId] = useState('');
  const [editState, setEditState] = useState(initialCreate);
  const [isCreatingTask, setIsCreatingTask] = useState(false);
  const [openCreateModal, setOpenCreateModal] = useState(false)
  const [createState, setCreateState] = useState(initialCreate);
  const [scheduledDate, setScheduledDate] = useState(new Date());
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [modalDroppedAlert, setModalDroppedAlert] = useState(false);
  const [isDescriptionModal, setIsDescriptionModal] = useState(false);
  const { allCampaign, campaignLogs } = useSelector(st => st.Campaign);
  const [isScheduleConfirmed, setIsScheduleConfirmed] = useState(false);
  const [isEditCampaignModal, setIsEditCampaignModal] = useState(false);
  const [isCampaignLogsModal, setIsCampaignLogsModal] = useState(false);
  const toggleDropDwon = () => setDropdownOpen((prevState) => !prevState);
  const [isSchedulingModalOpen, setIsSchedulingModalOpen] = useState(false);
  const [isCreateNewCampaignModal, setIsCreateNewCampaignModal] = useState(false);


  const [selectedStatusDetails, setSelectedStatusDetails] = useState("");
  const [searchStatusDetails, setSearchStatusDetails] = useState("");
  const [openStatusDetails, setOpenStatusDetails] = useState(false);

  const [selectedNewestfirst, setSelectedNewestfirst] = useState("");
  const [searchNewestfirst, setSearchNewestfirst] = useState("");
  const [openNewestfirst, setOpenNewestfirst] = useState(false);



  const filteredoptionsStatusDetails = optionsStatus.filter((status) =>
    status.label.toLowerCase().includes(searchStatusDetails.toLowerCase())
  );

  const filteredoptionsNewestfirst = optionsNewestfirst.filter((status) =>
    status.label.toLowerCase().includes(searchNewestfirst.toLowerCase())
  );


  const handleSelectStatuesDetails = (value) => {
    setSearchStatusDetails("");
    setOpenStatusDetails(false);
    setSelectedStatusDetails(value);
  };


  const handleSelectNewestfirst = (value) => {
    setSearchNewestfirst("");
    setOpenNewestfirst(false);
    setSelectedNewestfirst(value);
  };


  useEffect(() => {
    dispatch(getAllCampaign());
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => (prevProgress >= 100 ? 10 : prevProgress + 10));
    }, 800);
    return () => {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    if (campaignLogs) setLogs(campaignLogs);
  }, [campaignLogs]);

  const toggleDescriptionModal = () => setIsDescriptionModal(st => !st);
  const toggleEditCampaignModal = () => setIsEditCampaignModal(st => !st);
  const toggleCreateNewCampaignModal = () => setIsCreateNewCampaignModal(st => !st);
  const toggleCampaignLogsModal = () => {
    setIsCampaignLogsModal(st => !st);
    setLogs(null);
  };

  const handleChange = e => setCreateState(st => ({ ...st, [e.target?.name]: e.target?.value }));
  const handleEditChange = e => setEditState(st => ({ ...st, [e.target?.name]: e.target?.value }))

  const handleCreateTask = e => {
    e.preventDefault();
    setIsCreatingTask(true);
    dispatch(createTask({
      data: { ...createState }, successCallback: () => {
        setIsCreatingTask(false);
        setIsCreateNewCampaignModal(false);
        setCreateState(initialCreate);
        setOpenCreateModal(false);
        dispatch(getAllCampaign());
      },
      failCallback: () => setIsCreatingTask(false)
    }))
  }


  const toggleSchedulingModal = () => {
    setIsSchedulingModalOpen((prevState) => !prevState);
    setIsScheduleConfirmed(false);
  };
  const handleScheduleConfirm = () => {
    console.log("Email scheduled for:", scheduledDate);
    setIsScheduleConfirmed(true);
    setTimeout(() => {
      toggleSchedulingModal();
    }, 1500);
  };

  const handleSchedule = () => {
    if (!scheduledDate || !scheduledTime) {
      setModalDroppedAlert(true);
      return;
    }

    try {
      const campaignId = selectedCampaign._id;
      console.log("Scheduled Date:", scheduledDate);
      console.log("Scheduled Time:", scheduledTime);
      // Combine scheduledDate and scheduledTime into a single Date object
      const scheduledDateTime = new Date(`${scheduledDate}T${scheduledTime}`);
      // Create a payload to send to the backend or saga
      const payload = {
        campaignId,
        scheduledDate,  // Ensure these are sent correctly
        scheduledTime,
        scheduledDateTime,
      };
      console.log(payload, "payload")
      // Call the saga or backend function with the payload
      dispatch(createScheduleEmail({
        data: payload, campaignId,
      }));
      dispatch(getAllCampaign());
      toast.success("Email scheduled successfully");

      console.log(`Email scheduled for campaign ID ${campaignId} on ${scheduledDateTime}`);
    } catch (error) {
      console.error("Error during schedule email:", error.message);
    }
    handleScheduleConfirm();
    getAllCampaign();
  };


  const handleTabsSet = (event, newValue) => {
    setValue(newValue);
  };

  const handleEditTask = e => {
    e.preventDefault()

    setIsEditing(true)
    dispatch(updateTask({
      id: editState.id,
      data: {
        name: editState['name'],
        assistantId: editState['assistantId'],
        callsInterval: editState['callsInterval'],
        intervalTime: editState['intervalTime'],
        // location: editState['location'],
      },
      id: editState._id,
      successCallback: () => {
        setIsEditCampaignModal(false)
        setIsEditing(false)
        setEditState(initialCreate);

        dispatch(getAllCampaign());
      },

      failCallback: () => setIsEditing(false)
    }))
  }

  const columns = [{
    id: 'name',
    Header:
      <div className='checkbox-header-table'>
        <Checkbox /> Name
        <div className='email-hover-box'>
          <div className='box-check'>
            <Checkbox /> Select this page
          </div>
          <div className='box-check'>
            <Checkbox /> Select all (09)
          </div>
        </div>
      </div>,
    accessor: campaign =>
      <div className='checkbox'>
        <Checkbox />
        <p>{campaign['name'] || '-'}</p>
      </div>,
  },
  {
    id: 'status',
    Header: 'Status',
    accessor: campaign =>
      <div className='content-area'>
        {campaign['inQueue'] && <i class='fa fa-spinner fa-spin fa-lg px-2' style={{ color: 'green', cursor: 'progress' }} aria-hidden='true' title='Campaign Running' />}
        <button className={`status-btn ${campaign['status']}-btn`}>{campaign['status'].toUpperCase()}</button>
      </div>,
    filterable: false,
  },

  {
    id: 'progress',
    Header: 'Progress',
    accessor: campaign =>
      <div className='content-area content-progress'>
        <LinearProgressWithLabel value={30} />
      </div>,
    filterable: false,
  },
  // }, {
  //   id: 'intervalTime',
  //   Header: 'Interval Time',
  //   minWidth: 70,
  //   accessor: campaign => campaign['intervalTime'] || '-',
  // }, {
  //   id: 'callsInterval',
  //   Header: 'Interval Calls',
  //   minWidth: 130,
  //   accessor: campaign => campaign['callsInterval'] || '-',
  // }, {
  //   id: 'assistantId',
  //   minWidth: 70,
  //   Header: 'Assistant',
  //   accessor: campaign => campaign.assistant ? campaign.assistant.name : 'Unknown'

  // },
  {
    id: 'sent',
    Header: 'Sent',
    accessor: campaign => '894',
  },
  {
    id: 'click',
    Header: 'Click',
    accessor: campaign => '61',
  },
  {
    id: 'replied',
    Header: 'Replied',
    accessor: campaign => <p>0 <span>0.0%</span></p>,
  },
  {
    id: 'opportunities',
    Header: 'Opportunities ',
    accessor: campaign => '-',
  },
  // {
  //   id: 'lastExecuted',
  //   minWidth: 100,
  //   Header: 'Last Executed',
  //   accessor: campaign => campaign['prevExecAt'] ? moment(campaign['prevExecAt']).fromNow() : 'Not Executed',
  //   accessor: campaign => campaign['lastExecuted'] ? moment(campaign['lastExecuted']).fromNow() : 'Not Executed',
  // }, 
  {
    id: 'actions',
    Header: '',
    minWidth: 30,
    accessor: campaign =>
      <div className='content-area'>
        {/* If Campaign is New */}
        {['new'].includes(campaign['status']) &&
          <button className='check-btn' title='Approve Campaign' onClick={() => dispatch(updateStatus({ status: 'active', id: campaign['_id'] }))}>
            <i className='fa fa-check' aria-hidden='true'></i>
          </button>
        }
        {/* If Campaign is Active */}
        {['active'].includes(campaign['status']) &&
          <button className='pause-btn-chamgion' title='Pause Campaign' onClick={() => dispatch(updateStatus({ status: 'pause', id: campaign['_id'] }))}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 19V5H18V19H14ZM6 19V5H10V19H6Z" fill="#4b5563" /></svg>
          </button>
        }
        {/* If Campaign is Paused */}
        {['pause'].includes(campaign['status']) &&
          <button className='play-btn' title='Run Campaign' onClick={() => dispatch(updateStatus({ status: 'active', id: campaign['_id'] }))}>
            <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L15 10L1 19V1Z" stroke="#2ECA8B" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
        }

        <button className='tabs-page' onClick={() => {
          dispatch(getSingleTask(campaign['_id']));
          history.push(getWorkspacePath(`/campaigns/${campaign['_id']}`, currentWorkspace?._id));
          setIsVisible(true)
        }}><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="black" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" /><path d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z" stroke="black" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" /><path d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z" stroke="black" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" /></svg></button>

        {/* <button className='ml-1 view-btn user-view-btn' onClick={() => {
          dispatch(getSingleTask(campaign['_id']));
          history.push(getWorkspacePath(`/campaigns/${campaign['_id']}`, currentWorkspace?._id));
          setIsVisible(true)
        }}>
          <i className='tim-icons icon-pencil' />
        </button> */}

        {/* <button className='mx-1 delete-btn' title='Delete Campaign' onClick={() => dispatch(deleteSingleCampaign(campaign['_id']))}>
          <i className='fa fa-trash success px-2' aria-hidden='true' />
        </button> */}
        {/* <button
          title='Campaign Schedule'
          className='ml-1 view-btn user-view-btn'
          onClick={() => {
            setSelectedCampaign(campaign);
            toggleSchedulingModal();
          }}
        >
          <img
            src="https://img.icons8.com/ios-filled/50/000000/clock--v1.png"
            alt="Schedule Icon"
            style={{ width: '24px', height: '24px', marginRight: '8px' }}
          />
        </button> */}
        {/* <button title='Campaign Schedule' className='ml-1 view-btn user-view-btn' onClick={() => {
          setLogsCampaignId(campaign['_id']);
          dispatch(getCampaignLogs(campaign['_id']));
          toggleCampaignLogsModal();
        }}>
          <i className='fa fa-history' />
        </button> */}
      </div>,
    filterable: false,
  }];

  return (

    <div className='content'>
      {isVisible
        ? <CampaignDetails isVisible={isVisible} setIsVisible={setIsVisible} />
        : <div className='main-container'>
          <div className='bottom-content-area'>
            <div className='tabs-content'>
              <div className='content'>
                <div className='allemails-area campaign-page'>
                  <div className='row'>
                    <div className='col-lg-4 col-md-6 col-sm-6'>
                      <div className='searchbox'>
                        <i className='icon'>
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_224_579)">
                              <path d="M17.8568 16.2345L13.203 11.5807C14.0782 10.377 14.5958 8.8965 14.5958 7.2975C14.5958 3.27375 11.322 0 7.2975 0C3.27375 0 0 3.27375 0 7.2975C0 11.322 3.27375 14.595 7.2975 14.595C8.823 14.595 10.2397 14.1247 11.4128 13.3215L16.0912 18L17.8568 16.2345ZM2.1405 7.2975C2.1405 4.4535 4.45425 2.13975 7.29825 2.13975C10.1423 2.13975 12.456 4.4535 12.456 7.2975C12.456 10.1415 10.1423 12.4552 7.29825 12.4552C4.4535 12.4552 2.1405 10.1415 2.1405 7.2975Z" fill="#89868D" />
                            </g>
                            <defs>
                              <clipPath id="clip0_224_579">
                                <rect width="18" height="18" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </i>
                        <TextField
                          fullWidth
                          hiddenLabel
                          placeholder='Search...'
                          variant="standard"
                          size="small"
                          // value={editState?.type || agentData?.type || ''}
                          // onChange={handleEditChange}
                          name='search'
                        />
                      </div>
                    </div>
                    <div className='col-lg-8 col-md-6 col-sm-6'>
                      <div className='right-btn-area'>
                        <div className='filter-box'>
                          <FormControl fullWidth>
                            <Select
                              open={openStatusDetails}
                              onOpen={() => setOpenStatusDetails(true)}
                              onClose={() => setOpenStatusDetails(false)}
                              value={selectedStatusDetails}
                              onChange={(e) => handleSelectStatuesDetails(e.target.value)}
                              displayEmpty
                              renderValue={(selected) => {
                                if (!selected) return "Select Status"; // Show placeholder when nothing is selected

                                const selectedOption = optionsStatus.find((option) => option.label === selected);

                                return selectedOption ? (
                                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <i style={{ marginRight: "6px" }}>{selectedOption.icon}</i>
                                    <Typography sx={{ fontSize: "14px" }}>{selectedOption.label}</Typography>
                                  </Box>
                                ) : null;
                              }}
                              MenuProps={{
                                disableAutoFocusItem: true, // Prevent auto-focus issue
                              }}
                            >
                              {/* Search Field - Keeps Dropdown Open on Click */}
                              <MenuItem disableRipple>
                                <TextField
                                  fullWidth
                                  variant="standard"
                                  placeholder="Search..."
                                  value={searchStatusDetails}
                                  onChange={(e) => setSearchStatusDetails(e.target.value)}
                                  onClick={(e) => e.stopPropagation()} // Prevent dropdown from closing on click
                                  autoFocus
                                />
                              </MenuItem>

                              {/* Show Filtered Options */}
                              {filteredoptionsStatusDetails.length > 0 ? (
                                filteredoptionsStatusDetails.map((status) => (
                                  <MenuItem key={status.label} value={status.label} onClick={() => handleSelectStatuesDetails(status.label)}>
                                    <i style={{ marginRight: "6px" }}>{status.icon}</i> {status.label}
                                  </MenuItem>
                                ))
                              ) : (
                                <MenuItem disabled>No results found</MenuItem>
                              )}
                            </Select>
                          </FormControl>
                        </div>

                        <div className='filter-box'>
                          <FormControl fullWidth>
                            <Select
                              open={openNewestfirst}
                              onOpen={() => setOpenNewestfirst(true)}
                              onClose={() => setOpenNewestfirst(false)}
                              value={selectedNewestfirst}
                              onChange={(e) => handleSelectNewestfirst(e.target.value)}
                              displayEmpty
                              renderValue={(selected) => {
                                if (!selected) return "Select Status"; // Show placeholder when nothing is selected

                                const selectedOption = optionsNewestfirst.find((option) => option.label === selected);

                                return selectedOption ? (
                                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <i style={{ marginRight: "6px" }}>{selectedOption.icon}</i>
                                    <Typography sx={{ fontSize: "14px" }}>{selectedOption.label}</Typography>
                                  </Box>
                                ) : null;
                              }}
                              MenuProps={{
                                disableAutoFocusItem: true, // Prevent auto-focus issue
                              }}
                            >
                              {/* Search Field - Keeps Dropdown Open on Click */}
                              <MenuItem disableRipple>
                                <TextField
                                  fullWidth
                                  variant="standard"
                                  placeholder="Search..."
                                  value={searchNewestfirst}
                                  onChange={(e) => setSearchNewestfirst(e.target.value)}
                                  onClick={(e) => e.stopPropagation()} // Prevent dropdown from closing on click
                                  autoFocus
                                />
                              </MenuItem>

                              {/* Show Filtered Options */}
                              {filteredoptionsNewestfirst.length > 0 ? (
                                filteredoptionsNewestfirst.map((status) => (
                                  <MenuItem key={status.label} value={status.label} onClick={() => handleSelectNewestfirst(status.label)}>
                                    <i style={{ marginRight: "6px" }}>{status.icon}</i> {status.label}
                                  </MenuItem>
                                ))
                              ) : (
                                <MenuItem disabled>No results found</MenuItem>
                              )}
                            </Select>
                          </FormControl>
                        </div>
                        <button className='btn-style-new' onClick={() => setOpenCreateModal(true)}
                        >
                          <i className='icon'><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19" stroke="#fff" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" /><path d="M5 12H19" stroke="#fff" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" /></svg></i>
                          Add new
                        </button>
                      </div>
                    </div>
                    <div className='col-12'>
                      <div className="table-container">
                        <ReactTable
                          width='100'
                          className='table campaign-table responsive '
                          minRows={6}
                          columns={columns}
                          filterable={false}
                          showPagination={false}
                          data={Array.isArray(allCampaign) ? allCampaign : []}
                          defaultFilterMethod={filterCaseInsensitive}
                          resolveData={allCampaign => allCampaign.map(row => row)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      {/* to create a new campaign modal */}
      <CreateCampaignModal
        isOpenNew={openCreateModal}
        toggle={() => setOpenCreateModal(false)}
        title={'Create a Campaign'}
        state={createState}
        handleChange={handleChange}
        handleSubmit={handleCreateTask}
        isSubmitting={isCreatingTask}
      />

      <CampaignModal isOpenEdit={isEditCampaignModal} setOpen={setIsEditCampaignModal}
        title={'Edit a Campaign'} state={editState} handleChange={handleEditChange} handleSubmit={handleEditTask}
        isSubmitting={isEditing} />

      {/* --------------- Description Moodal--------------- */}
      <Modal isOpen={isDescriptionModal} toggle={toggleDescriptionModal} className={`main-modal modal-dialog-centered new-user-modal`}>
        <ModalHeader toggle={toggleDescriptionModal}></ModalHeader>
        <ModalBody>
          <div className='content-area'>
            <h2>Description Details</h2>
            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.'</p>
          </div>
        </ModalBody>
      </Modal>

      {/* --------------- Campaign Logs Moodal--------------- */}
      <Modal isOpen={isCampaignLogsModal} toggle={toggleCampaignLogsModal} className={`main-modal modal-dialog-centered new-user-modal`}>
        <ModalHeader toggle={toggleCampaignLogsModal}>
          <button className='refresh-icon' onClick={() => {
            setLogs(null);
            dispatch(getCampaignLogs(logsCampaignId))
          }}>
            <i className='icon' aria-hidden='true'>
              <svg version='1.1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 383.748 383.748'>
                <g>
                  <path d='M62.772,95.042C90.904,54.899,137.496,30,187.343,30c83.743,0,151.874,68.13,151.874,151.874h30
                        C369.217,81.588,287.629,0,187.343,0c-35.038,0-69.061,9.989-98.391,28.888C70.368,40.862,54.245,56.032,41.221,73.593
                        L2.081,34.641v113.365h113.91L62.772,95.042z'/>
                  <path d='M381.667,235.742h-113.91l53.219,52.965c-28.132,40.142-74.724,65.042-124.571,65.042
                        c-83.744,0-151.874-68.13-151.874-151.874h-30c0,100.286,81.588,181.874,181.874,181.874c35.038,0,69.062-9.989,98.391-28.888
                        c18.584-11.975,34.707-27.145,47.731-44.706l39.139,38.952V235.742z'/>
                </g>
              </svg>
            </i>
          </button>
        </ModalHeader>
      </Modal>
      <Modal isOpen={isSchedulingModalOpen} toggle={toggleSchedulingModal} className='main-modal email-scheduling-modal'>
        <ModalHeader toggle={toggleSchedulingModal}>
          <div className='modal-header-content'>
            <img
              src='https://img.icons8.com/ios-filled/50/000000/clock--v1.png'
              alt='Schedule Icon'
              style={{ width: '24px', marginRight: '8px' }}
            />
            Schedule Email
          </div>
        </ModalHeader>
        <ModalBody>
          {!isScheduleConfirmed ? (
            <div className='content-area scheduling-modal'>
              <h2>Select Date and Time</h2>
              <div className='datepicker-container'>
                <input
                  type="date"
                  id="scheduleDate"
                  value={scheduledDate}
                  onChange={(e) => setScheduledDate(e.target.value)}
                  className="form-control"
                />
                <input
                  type="time"
                  id="scheduleTime"
                  value={scheduledTime}
                  onChange={(e) => setScheduledTime(e.target.value)}
                  className="form-control"
                />
              </div>
              <div className='modal-actions'>
                <Button color='primary' onClick={handleSchedule}>Schedule</Button>
                <Button color='secondary' onClick={toggleSchedulingModal}>Cancel</Button>
              </div>
            </div>
          ) : (
            <div className='content-area scheduling-modal'>
              <h2>Meeting Scheduled</h2>
              <p>Your email has been scheduled for {moment(scheduledDate).format('MMMM Do YYYY')} at {scheduledTime}.</p>
            </div>
          )}
        </ModalBody>
      </Modal>

      {/* --------------- Altert Dropped--------------- */}
         <Modal isOpen={modalDroppedAlert} toggle={() => setModalDroppedAlert(false)} className={`main-modal new-user-modal modal-dialog-centered`}>
            <ModalHeader toggle={() => setModalDroppedAlert(false)}></ModalHeader>
            <ModalBody>
               <div className='add-content'>
                  <h2>Please select both date and time!</h2>
                  <div className='templates-inner'>
                     <div className='btn-group'>
                        <button className='btn-style-new' onClick={() => setModalDroppedAlert(false)}>Ok</button>
                     </div>
                  </div>
               </div>
            </ModalBody>
         </Modal>
    </div>
  );
};

export default Campaign;